import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]

  connect() {
    if (!this.hasTextTarget) return

    this.textTarget.focus()
    this.resize()
  }

  resize() {
    if (!this.hasTextTarget) return

    window.setTimeout(() => {
      this.textTarget.style.height = "auto"
      this.textTarget.style.height = `${this.textTarget.scrollHeight}px`
    }, 0)
  }
}
